import { useState } from 'react';
import { useSelector } from 'react-redux';
import { debugSentryState } from '../utils/sentry';

const SentryTestButton = () => {
	const [isVisible, setIsVisible] = useState(true);
	const { organization, user } = useSelector((state) => state.header);

	const logDebugInfo = () => {
		console.log('🔍 Redux State Debug Info:');
		console.log('  - Current URL:', window.location.pathname);
		console.log('  - Redux organization:', organization);
		console.log('  - Organization name:', organization?.name);
		console.log('  - User:', user);
		console.log('  - Environment:', import.meta.env.VITE_API_ENVIRONMENT);
		console.log(
			'  - Sentry DSN configured:',
			!!import.meta.env.VITE_SENTRY_DSN
		);

		// Also call the Sentry debug function
		debugSentryState();
	};

	// Only show in non-production environments
	if (import.meta.env.VITE_API_ENVIRONMENT === 'production') {
		return null;
	}

	if (!isVisible) {
		return (
			<button
				onClick={() => setIsVisible(true)}
				className="fixed bottom-4 right-4 z-50 rounded-full bg-red-500 p-2 text-white shadow-lg transition-colors duration-200 hover:bg-red-600"
				title="Show Sentry Test Button"
			>
				🐛
			</button>
		);
	}

	return (
		<div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2">
			<button
				onClick={() => {
					throw new Error('Do it again!');
				}}
				className="rounded-lg bg-red-500 px-4 py-2 text-sm font-medium text-white shadow-lg transition-colors duration-200 hover:bg-red-600"
			>
				Break the world
			</button>
			<button
				onClick={logDebugInfo}
				className="rounded-lg bg-blue-500 px-4 py-2 text-sm font-medium text-white shadow-lg transition-colors duration-200 hover:bg-blue-600"
				title="Log debug info to console"
			>
				Debug Info
			</button>
			<button
				onClick={() => setIsVisible(false)}
				className="bg-base-500 hover:bg-base-600 rounded px-2 py-1 text-xs text-white"
				title="Hide test button"
			>
				Hide
			</button>
		</div>
	);
};

export default SentryTestButton;
